<template>
    <form @submit.prevent="$emit('onEvent', data)">
        <app-model :class="{ 'show': show }">
            <template v-slot:header class="modal-header d-flex align-items-center">
                <h4 class="card-title mb-0">Actualizar registro</h4>
                <button type="button" @click="onClose()" class="btn-close"></button>
            </template>
            <template v-slot:body class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group mb-3">
                          <label class="control-label">Hora inicio</label>
                          <v-app>
                            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                              :return-value.sync="data.start_time" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="data.start_time" dense hide-details outlined class="form-control d-flex" placeholder="00:00" prepend-icon="mdi-clock" readonly
                                  v-bind="attrs" v-on="on"></v-text-field>
                              </template>
                              <v-time-picker v-if="menu1" v-model="data.start_time" format="24hr" no-title
                                @click:minute="$refs.menu1.save(data.start_time)"></v-time-picker>
                            </v-menu>
                          </v-app>
                        </div>
                        <div class="form-group mb-3">
                          <label class="control-label">Hora inicio</label>
                          <v-app>
                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                              :return-value.sync="data.end_time" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="data.end_time" dense hide-details outlined class="form-control d-flex" placeholder="00:00" prepend-icon="mdi-clock" readonly
                                  v-bind="attrs" v-on="on"></v-text-field>
                              </template>
                              <v-time-picker v-if="menu2" v-model="data.end_time" format="24hr" no-title
                                @click:minute="$refs.menu2.save(data.end_time)"></v-time-picker>
                            </v-menu>
                          </v-app>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer class="modal-footer">
                <button type="submit" class="btn btn-success rounded-pill px-4">
                    <span v-if="submit" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span :class="{ 'visually-hidden': submit }">
                        <i class="ti ti-device-floppy me-1 fs-4"></i> Guardar cambios
                    </span>
                </button>
                <button type="button" @click="onClose()"
                    class="btn btn-danger rounded-pill px-4 ms-2 text-white">Cancelar</button>
            </template>
        </app-model>
    </form>
</template>
<script>
export default {
  props: {
    id: {
      type: String | Number,
      default: null
    },
    submit: {
      type: Boolean,
      default: false
    },
    onEvent: {
      type: Function,
      default: () => { console.log('aca') }
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      show: false,
      menu1: false,
      menu2: false
    }
  },
  created () {
    setInterval(() => {
      if (this.id) {
        this.show = true
      }
    }, 100)
  },
  methods: {
    onClose: function () {
      this.show = false
      this.$emit('onClose')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/schedules/models/Update.vue